import React from 'react';
import TryAgainFooterButtons from '../../../components/Buttons/TryAgainFooterButtons.jsx';
import TryAgainReturnToLoginButtons from '../../../components/Buttons/TryAgainReturnToLogin.jsx';
import { PhoneNumberInput } from '../PhoneNumberInput.jsx';
import { UsernameInput } from './UsernameInput.jsx';
import { PasswordInput } from './PasswordInput.jsx';
import TranslationText from "components/components/Translation/TranslationText.jsx";
import { PasswordRecoveryLinks } from "components/components/Buttons/PasswordRecoveryLinks.jsx";

export function PasswordLoginForm({
	state,
	onSubmit,
	onChange,
	onBeginRecaptchaValidation,
	onResetInitialState,
	onDropDownChange,
	initialData,
}) {
	const {
		errors,
		businessLogin,
		model,
		phoneError,
		isProcessing
	} = state;

	return (
		<form onSubmit={onSubmit} noValidate>
			{phoneError ? (
				<PhoneNumberInput
					model={model}
					errors={errors}
					businessLogin={businessLogin}
					onChange={onChange}
					onDropDownChange={onDropDownChange}
					initialData={initialData}
					{...state}
				/>
			) : (
				<UsernameInput
					model={model}
					errors={errors}
					businessLogin={businessLogin}
					onChange={onChange}
				/>
			)}

			<PasswordInput
				model={model}
				errors={errors}
				businessLogin={businessLogin}
				onChange={onChange}
			/>

			{phoneError ? (
				<TryAgainReturnToLogin
					Login={onBeginRecaptchaValidation}
					resetInitialState={onResetInitialState}
					isProcessing={isProcessing}
					businessLogin={businessLogin}
				/>
			) : (
				<div className="form-button full-width">
					<button
						type="submit"
						onClick={() => onBeginRecaptchaValidation()}
						className="button"
						disabled={isProcessing}
					>
						<TranslationText text={"login_button_label"} />
					</button>

					<PasswordRecoveryLinks businessLogin={businessLogin} />
				</div>
			)}
		</form>
	);
}